import StringEx from "../../LTGame/LTUtils/StringEx";
export default class ResDefine {
    static FixPath(filePath) {
        if (StringEx.IsNullOrEmpty(filePath)) {
            console.error("传入参数为空");
            return null;
        }
        return "res/export/Conventional/" + filePath + ".lh";
    }
    static FixScene(scenePath) {
        if (StringEx.IsNullOrEmpty(scenePath)) {
            console.error("传入参数为空");
            return null;
        }
        return "res/export/Conventional/" + scenePath + ".ls";
    }
    static FixMat(matPath) {
        if (StringEx.IsNullOrEmpty(matPath)) {
            console.error("传入参数为空");
            return null;
        }
        return "res/export/Conventional/Assets/_res/mat/" + matPath + ".lmat";
    }
}
ResDefine.HpPath = "xuetiao_01";
ResDefine.whiteMat = "white";
ResDefine.skillTypePath = {
    fire_rate: "gongsu",
    damage_rate: "shanghai"
};
ResDefine.timeTypePath = {
    Year: "nian",
    Day: "ri",
    People: "renshu",
    Month: "yue",
};
ResDefine.mathTypePath = {
    "+": "jia",
    "-": "jian",
    "*": "X",
    "/": "chu",
};
ResDefine.valuePath = {
    0: "shuzi_0",
    1: "shuzi_1",
    2: "shuzi_2",
    3: "shuzi_3",
    4: "shuzi_4",
    5: "shuzi_5",
    6: "shuzi_6",
    7: "shuzi_7",
    8: "shuzi_8",
    9: "shuzi_9"
};
